import { RecurrenceFormHandler } from "./RecurrenceFormHandler";

frappe.RecurrenceFormHandler = RecurrenceFormHandler
